// extracted by mini-css-extract-plugin
export default {"root":"MailtoSupport_root__BHR1A"};